var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("entity-editor", {
    attrs: {
      entity: "ritual",
      id: _vm.id,
      "api-name": "ritualCircles",
      "new-entity": _vm.newRitualCircle,
      "read-router-name": "readRitualCircle"
    },
    on: { isDirtyChange: _vm.handleIsDirtyChange },
    scopedSlots: _vm._u(
      [
        {
          key: `editor`,
          fn: function({ doc }) {
            return [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("v-text-field", {
                        attrs: { rules: [_vm.requiredRule] },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: `label`,
                              fn: function() {
                                return [
                                  _c("label-required", {
                                    attrs: { name: "name" }
                                  })
                                ]
                              },
                              proxy: true
                            }
                          ],
                          null,
                          true
                        ),
                        model: {
                          value: doc.name,
                          callback: function($$v) {
                            _vm.$set(doc, "name", $$v)
                          },
                          expression: "doc.name"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "6" } },
                    [
                      _c("v-select", {
                        attrs: {
                          rules: [_vm.requiredRule],
                          items: _vm.circleSize,
                          disabled: _vm.isLoading,
                          label: "Circle Size",
                          outlined: "",
                          dense: ""
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: `label`,
                              fn: function() {
                                return [
                                  _c("label-required", {
                                    attrs: { name: "Circle Size" }
                                  })
                                ]
                              },
                              proxy: true
                            }
                          ],
                          null,
                          true
                        ),
                        model: {
                          value: doc.size,
                          callback: function($$v) {
                            _vm.$set(doc, "size", $$v)
                          },
                          expression: "doc.size"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "3" } },
                    [
                      _c("v-checkbox", {
                        staticClass: "mt-1",
                        attrs: { label: "Is Active?", dense: "" },
                        model: {
                          value: doc.active,
                          callback: function($$v) {
                            _vm.$set(doc, "active", $$v)
                          },
                          expression: "doc.active"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "3" } },
                    [
                      _c("v-checkbox", {
                        staticClass: "mt-1",
                        attrs: { label: "Is Hidden?", dense: "" },
                        model: {
                          value: doc.isHidden,
                          callback: function($$v) {
                            _vm.$set(doc, "isHidden", $$v)
                          },
                          expression: "doc.isHidden"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("v-textarea", {
                        attrs: {
                          label: "Flavour",
                          rows: "2",
                          outlined: "",
                          "auto-grow": ""
                        },
                        model: {
                          value: doc.flavour,
                          callback: function($$v) {
                            _vm.$set(doc, "flavour", $$v)
                          },
                          expression: "doc.flavour"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("v-textarea", {
                        attrs: {
                          label: "Location",
                          rows: "2",
                          outlined: "",
                          "auto-grow": ""
                        },
                        model: {
                          value: doc.location,
                          callback: function($$v) {
                            _vm.$set(doc, "location", $$v)
                          },
                          expression: "doc.location"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("v-text-field", {
                        attrs: { label: "Bounce Location", outlined: "" },
                        model: {
                          value: doc.bounceLocation,
                          callback: function($$v) {
                            _vm.$set(doc, "bounceLocation", $$v)
                          },
                          expression: "doc.bounceLocation"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("v-textarea", {
                        attrs: {
                          label: "Description",
                          rows: "2",
                          outlined: "",
                          "auto-grow": ""
                        },
                        model: {
                          value: doc.description,
                          callback: function($$v) {
                            _vm.$set(doc, "description", $$v)
                          },
                          expression: "doc.description"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("v-textarea", {
                        attrs: {
                          label: "Notes",
                          rows: "2",
                          outlined: "",
                          "auto-grow": ""
                        },
                        model: {
                          value: doc.notes,
                          callback: function($$v) {
                            _vm.$set(doc, "notes", $$v)
                          },
                          expression: "doc.notes"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ]
          }
        }
      ],
      null,
      true
    )
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }